import { PickValue } from 'common/interfaces';
import { TooltipComponentProps } from 'components/tooltip-component/tooltip-component.props';

export const tooltipProps: PickValue<TooltipComponentProps, 'componentsProps'> = {
  arrow: { style: { color: 'rgba(0.2, 0.2, 0.2, 0.8)' } },
  tooltip: { style: { fontSize: 11, background: 'rgba(0.2, 0.2, 0.2, 0.8)', marginTop: 8 } }
};
